import React from 'react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Input from '@mui/material/TextField';

import TranslationIds from '../../../commons/translationIds';

function renderLastName (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        // subscribersFields,
        touched,
    } = p;

    if (!fields || !fields.name) {
        return (<React.Fragment></React.Fragment>);
    }

    function getLabel () {
        if (fields.name === 1 || fields.last_name === 1) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_LASTNAME)}*`;
        }
        return translate(TranslationIds.REGISTRATION_LABEL_LASTNAME);   
    }

    function getHelperText () {
        if (touched.last_name && fieldErrors.last_name) {
            return translate(TranslationIds.REGISTRATION_REQUIRED_LASTNAME);
        }
        return '';
    }

    function inputClass () {
        if (fieldErrors.last_name) {
            return classes.inputBaseError;
        }
        return classes.inputBase;
    }

    return (
        <Grid className={classNames(['ecal-reg-field-last_name', classes.fieldRoot])}>
            <span className={classNames(['ecal-input-label', classes.fieldLabel])}>
                {getLabel()}
            </span>

            <Input
                id="last_name"
                name="last_name"
                className={inputClass()}
                InputProps={{
                classes: {
                    underline: classes.InputUnderline,
                    input: classes.Input,
                },
                }}
                // value={subscribersFields.last_name}

                onChange={e => {
                    setSubscribersFields({
                        last_name: e.target.value,
                    },
                    {
                        selector: '#last_name',
                        field: 'last_name',
                    });
                }}

                onBlur={(e) => {
                    setSubscribersFields({
                        last_name: e.target.value,
                    });
                }}
            
                margin="normal"
                placeholder={translate(TranslationIds.REGISTRATION_LABEL_LASTNAME)}
                type="text"
                fullWidth
                error={ fieldErrors.last_name }
                helperText={getHelperText()} 
            />
        </Grid>
    );
}

export default renderLastName;